const SET_LOADER = 'SET_LOADER'

export const setLoader = (payload) => ({
  type: SET_LOADER,
  payload,
})

const initialState = {
  showLoader: 0,
}

const common = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADER:
      return { ...state, showLoader: action.payload ? state.showLoader + 1 : state.showLoader - 1 }
    default:
      return state
  }
}

export default common
